import "./About.css";
import logo from "../../assets/image/logo.png";
// import nxo from "../../assets/image/nxo.svg"; // optional NXO icon

export default function About() {
  return (
    <div className="about-page-dark">

      {/* HERO */}
      <section className="about-hero-dark">
        <div className="container">
          <h1>About NX Optics</h1>
          <p>Simplify Enterprise Network Design</p>
        </div>
      </section>

      {/* SUB MENU */}
      <div className="about-submenu-dark">
        <div className="container">
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#mission">Mission & Vision</a></li>
            <li><a href="#why">What Us</a></li>
          </ul>
        </div>
      </div>

      {/* ABOUT */}
      <section id="about" className="section-dark text-center">
        <div className="container narrow">
          <h2>About NX Optics</h2>
          <p>
            NX Optics is a specialized provider of optical networking solutions,
            offering SFP / SFP+ Optical Transceivers, CWDM modules, and Fiber
            Optic Cables for modern high-speed networks.
          </p>
          <p>
            We are committed to helping businesses build
            <strong> robust, scalable, future-ready infrastructure</strong>
            through reliable products and expert support.
          </p>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section id="mission" className="section-dark">
        <div className="container card-wrap">
          <div className="mv-card">
            <h6>Our Mission</h6>
            <p>
              To deliver high-performance optical networking products that ensure
              long-term reliability and efficiency.
            </p>
          </div>

          <div className="mv-card">
            <h6>Our Vision</h6>
            <p>
              To become a trusted global optical networking brand known for
              quality, transparency, and technical excellence.
            </p>
          </div>
        </div>
      </section>

      {/* WHY US (MATCHING YOUR SCREENSHOT) */}
      <section id="why" className="section-dark">
        <div className="container why-layout">

          {/* LEFT LOGO */}
          <div className="why-logo">
            <img src={logo} alt="NX Optics" />
            {/* <img src={nxo} alt="NXO" /> optional */}
          </div>

          {/* RIGHT CONTENT */}
          <div className="why-content">
            <h2>What Makes Us Different</h2>
            <ul>
              <li>Strict quality testing before dispatch</li>
              <li>Enterprise & telecom-grade deployments</li>
              <li>Short-range to long-haul product coverage</li>
              <li>Customer-first technical consultation</li>
            </ul>
            <p>
              Whether expanding a data center or deploying a city-wide fiber
              network, NX Optics is your dependable partner.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
}
